export default "__VITE_ASSET__83443fe9__"